import { buildStoreWhatsAppUrl, formatStorePhone, getStoreConfig } from "@/lib/storeConfig";

export default function PublicOrderStoreFooter() {
  const store = getStoreConfig();
  const whatsappUrl = buildStoreWhatsAppUrl("Здравствуйте!");
  const formattedPhone = formatStorePhone(store.phone);

  return (
    <footer className="mt-10 border-t border-slate-200 pt-8 pb-10 text-center text-sm text-slate-500">
      <p className="text-base font-semibold text-slate-800" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
        {store.name}
      </p>
      <p className="mt-1">{store.subtitle}</p>
      <p className="mt-3">Адрес: {store.address}</p>
      {formattedPhone && (
        <p className="mt-1">
          Телефон:{" "}
          <a href={`tel:${store.phone.replace(/\s/g, "")}`} className="text-blue-700 hover:underline">
            {formattedPhone}
          </a>
        </p>
      )}
      {whatsappUrl && (
        <p className="mt-1">
          WhatsApp:{" "}
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-emerald-700 hover:underline">
            написать
          </a>
        </p>
      )}
      {store.mapUrl && (
        <p className="mt-2">
          <a href={store.mapUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
            Открыть на карте
          </a>
        </p>
      )}
    </footer>
  );
}
